<template lang="pug">
div.nopadding
    div.fullwidth(v-if="$route.params.lang == 'en'")
        div.padding
            h1.title.secondary-header.no-margin Career
            ColumnContainer
                .column.career-text(slot='left')
                    
                    h2 Ready to Make a Real Difference?
                    p At BSS, we develop advanced monitoring systems and sensors for the energy infrastructure of tomorrow. Behind every solution is a team of dedicated people who turn ideas into practical products.
                    p With us, you are more than just a number working on isolated subtasks. You actively shape things, contribute your own ideas, and see first‑hand how your efforts support the reliable operation of critical electrical assets.
                    p Instead of rigid hierarchies and endless meetings, we rely on direct communication, personal responsibility, and short decision-making paths. Good ideas are implemented with us, not just managed.

                .column.career-image-column.center-content(slot='right')
                    Carousel.career-carousel(:perPage="1", autoplay=true, :autoplayTimeout="3500", loop=true, navigationEnabled=true, :paginationEnabled="false")
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-a1.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-a1.jpg')", width='100%', alt='Collaborative development work at BSS', title='Collaborative development work at BSS')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-a2.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-a2.jpg')", width='100%', alt='Working on a CNC Milling Machine', title='Working on a CNC Milling Machine')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-a3.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-a3.jpg')", width='100%', alt='Collaborative work on a test setup', title='Collaborative work on a test setup')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-a4.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-a4.jpg')", width='100%', alt='Development in the workshop', title='Development in the workshop')

        Section(color='color3')
            ColumnContainer(reverse)
                .column.career-text(slot='left')
                    h2 Our Team & Your Workplace
                    p We are a young, highly specialized team developing solutions for customers and partners worldwide. Short communication channels, mutual support, and a shared enthusiasm for technically demanding solutions characterize our collaboration.
                    p You can find us at our two locations in Sindelfingen and Stuttgart-Möhringen. We skip the cliché fruit basket – instead, we offer free coffee, fresh cake from time to time, and our office dog Nala, who keeps spirits high.
                .column.career-image-column.center-content(slot='right')
                    Carousel.career-carousel(:perPage="1", autoplay=true, :autoplayTimeout="3500", loop=true, navigationEnabled=true, :paginationEnabled="false")
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b1.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b1.jpg')", width='100%', alt='Team canoe outing', title='Team canoe outing')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b2.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b2.jpg')", width='100%', alt='Team lunch together', title='Team lunch together')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b3.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b3.jpg')", width='100%', alt='Teamwork at the workplace', title='Teamwork at the workplace')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b4.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b4.jpg')", width='100%', alt='Coffee Break', title='Coffee Break')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b5.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b5.jpg')", width='100%', alt='Office dog Nala', title='Office dog Nala')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b6.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b6.jpg')", width='100%', alt='Team celebration', title='Team celebration')

        Section(color='grey').padding.career-benefits
            h2 What We Offer You:
            .career-benefits-grid
                MethodBox(title='Modern Workplace')
                    template(#icon)
                        svg(viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                            rect(x="3" y="4" width="18" height="12" rx="2")
                            path(d="M8 20h8")
                            path(d="M12 16v4")
                    p Ergonomic and air-conditioned workspaces with height-adjustable desks and modern IT equipment await you.
                MethodBox(title='Flexible Working Hours')
                    template(#icon)
                        svg(viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                            circle(cx="12" cy="12" r="9")
                            polyline(points="12 7 12 12 16 14")
                    p Flexible working hours help you balance work and personal commitments.
                MethodBox(title='True Team Spirit')
                    template(#icon)
                        svg(viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                            circle(cx="9" cy="8" r="3")
                            circle(cx="17" cy="9" r="2.5")
                            path(d="M3 19c0-3 2.7-5 6-5s6 2 6 5")
                            path(d="M14 15c.8-.4 1.8-.6 2.8-.6 2.4 0 4.2 1.3 4.2 3.6")
                    p Whether it's a company outing or a team dinner, collaboration and camaraderie extend beyond the workplace.
                MethodBox(title='Financial Benefits')
                    template(#icon)
                        svg(viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                            circle(cx="12" cy="12" r="9")
                            path(d="M15 8.5c-.7-.6-1.7-1-3-1-1.7 0-3 1-3 2.2s1.1 1.8 3 2.3 3 1.1 3 2.3-1.3 2.2-3 2.2c-1.3 0-2.3-.4-3-1")
                            path(d="M12 6v12")
                    p In addition to your salary, you receive a monthly tax‑free benefits allowance of €50.
                MethodBox(title='Excellent Connectivity')
                    template(#icon)
                        svg(viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                            path(d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0z")
                            circle(cx="12" cy="10" r="2")
                    p Whether by car or public transport, both locations are excellently accessible.
            
        Section
            h2 Current Job Openings
            Downloadlink(text='Software Developer (m/f/d) for Embedded Linux & Low-Level Data Processing', link="/pdf/SW-Entwickler BSS Hochspannungstechnik 2026-11.pdf")
            // p Currently no open job postings.
            ContactButton(
                text="Send Application"
                to="mailto:bewerbung@bss-hs.de"
                external
            )
                span(slot="title") Want to Get to Know Us?
                span(slot="subtitle")
                    | We are looking for people who take initiative, enjoy solving technical challenges, and bring new ideas to the table. Explore our current openings or send us an unsolicited application at: 
                    a(href="mailto:bewerbung@bss-hs.de") bewerbung@bss-hs.de

    div.fullwidth(v-if="$route.params.lang == 'de'")
        div.padding
            h1.title.secondary-header.no-margin Karriere
            ColumnContainer
                .column.career-text(slot='left')
                    
                    h2 Bereit, wirklich etwas zu bewegen?
                    p Bei BSS entwickeln wir zukunftsweisende Monitoringsysteme und Sensorik für die Energieversorgung von morgen. Doch unsere wichtigste Antriebskraft sind die Menschen dahinter.

                    p Bei uns bist du keine Personalnummer und arbeitest nicht an isolierten Teilaufgaben. Du gestaltest aktiv mit, übernimmst Verantwortung und siehst direkt, welchen Beitrag deine Arbeit für den sicheren Betrieb kritischer Energieinfrastruktur leistet.

                    p Statt auf starre Hierarchien und endlose Meetings setzen wir auf direkten Austausch, Eigenverantwortung und kurze Entscheidungswege. Gute Ideen werden bei uns umgesetzt, nicht verwaltet.

                .column.career-image-column.center-content(slot='right')
                    Carousel.career-carousel(:perPage="1", autoplay=true, :autoplayTimeout="3500", loop=true, navigationEnabled=true, :paginationEnabled="false")
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-a1.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-a1.jpg')", width='100%', alt='Gemeinsame Entwicklungsarbeit bei BSS', title='Gemeinsame Entwicklungsarbeit bei BSS')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-a2.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-a2.jpg')", width='100%', alt='Arbeiten an einer CNC-Fräse', title='Arbeiten an einer CNC-Fräse')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-a3.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-a3.jpg')", width='100%', alt='Gemeinsame Arbeit an einem Prüfaufbau', title='Gemeinsame Arbeit an einem Prüfaufbau')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-a4.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-a4.jpg')", width='100%', alt='Entwicklung in der Werkstatt', title='Entwicklung in der Werkstatt')

        Section(color='color3')
            ColumnContainer(reverse)
                .column.career-text(slot='left')
                    h2 Unser Team & dein Arbeitsplatz
                    p Wir sind ein junges, hochspezialisiertes Team und entwickeln Lösungen für Kunden und Partner weltweit. Kurze Abstimmungswege, gegenseitige Unterstützung und die gemeinsame Begeisterung für technisch anspruchsvolle Lösungen prägen unsere Zusammenarbeit.
                    p Du findest uns an unseren beiden Standorten in Sindelfingen und Stuttgart‑Möhringen. Auf den klischeehaften Obstkorb verzichten wir, dafür gibt es bei uns Kaffee aufs Haus, immer mal wieder frischen Kuchen und unseren Bürohund Nala, der für gute Stimmung sorgt.
                .column.career-image-column.center-content(slot='right')
                    Carousel.career-carousel(:perPage="1", autoplay=true, :autoplayTimeout="3500", loop=true, navigationEnabled=true, :paginationEnabled="false")
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b1.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b1.jpg')", width='100%', alt='Gemeinsamer Ausflug im Kanu', title='Gemeinsamer Ausflug im Kanu')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b2.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b2.jpg')", width='100%', alt='Gemeinsames Essen im Team', title='Gemeinsames Essen im Team')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b3.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b3.jpg')", width='100%', alt='Teamarbeit am Arbeitsplatz', title='Teamarbeit am Arbeitsplatz')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b4.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b4.jpg')", width='100%', alt='Kaffeepause', title='Kaffeepause')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b5.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b5.jpg')", width='100%', alt='Bürohund Nala', title='Bürohund Nala')
                        Slide.img-center
                            picture
                                source(type='image/webp', :srcset="require('@/assets/photos/career/career-b6.webp')")
                                img.career-image(:src="require('@/assets/photos/career/career-b6.jpg')", width='100%', alt='Feiern im Büro', title='Feiern im Büro')

        Section(color='grey').padding.career-benefits
            h2 Was wir dir bieten:
            .career-benefits-grid
                MethodBox(title='Top Ausstattung')
                    template(#icon)
                        svg(viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                            rect(x="3" y="4" width="18" height="12" rx="2")
                            path(d="M8 20h8")
                            path(d="M12 16v4")
                    p Dich erwarten ergonomische und klimatisierte Arbeitsplätze mit höhenverstellbaren Schreibtischen und moderner IT-Ausstattung.
                MethodBox(title='Flexible Arbeitszeiten')
                    template(#icon)
                        svg(viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                            circle(cx="12" cy="12" r="9")
                            polyline(points="12 7 12 12 16 14")
                    p Dank unseres Gleitzeitmodells kannst du deinen Arbeitsalltag flexibel gestalten.
                MethodBox(title='Echter Teamspirit')
                    template(#icon)
                        svg(viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                            circle(cx="9" cy="8" r="3")
                            circle(cx="17" cy="9" r="2.5")
                            path(d="M3 19c0-3 2.7-5 6-5s6 2 6 5")
                            path(d="M14 15c.8-.4 1.8-.6 2.8-.6 2.4 0 4.2 1.3 4.2 3.6")
                    p Ob Betriebsausflug oder gemeinsames Abendessen – auch außerhalb des Arbeitsalltags kommt das Miteinander nicht zu kurz.
                MethodBox(title='Finanzielles Extra')
                    template(#icon)
                        svg(viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                            circle(cx="12" cy="12" r="9")
                            path(d="M15 8.5c-.7-.6-1.7-1-3-1-1.7 0-3 1-3 2.2s1.1 1.8 3 2.3 3 1.1 3 2.3-1.3 2.2-3 2.2c-1.3 0-2.3-.4-3-1")
                            path(d="M12 6v12")
                    p On top zu deinem Gehalt erhältst du monatlich 50 Euro als steuerfreien Sachbezug.
                MethodBox(title='Beste Anbindung')
                    template(#icon)
                        svg(viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
                            path(d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0z")
                            circle(cx="12" cy="10" r="2")
                    p Egal, ob Auto oder ÖPNV, du erreichst beide Standorte hervorragend.
            
        Section
            h2 Aktuelle Stellenausschreibungen
            Downloadlink(text='Softwareentwickler (m/w/d) für Embedded Linux & Systemnahe Datenverarbeitung', link="/pdf/SW-Entwickler BSS Hochspannungstechnik 2026-11.pdf")
            //p Aktuell keine offenen Stellenausschreibungen.
            ContactButton(
                text="Bewerbung senden"
                to="mailto:bewerbung@bss-hs.de"
                external
            )
                span(slot="title") Lust, uns kennenzulernen?
                span(slot="subtitle")
                    | Wir suchen Menschen, die mitdenken, anpacken und neue Ideen einbringen. Schau dir unsere offenen Stellen an oder sende uns eine Initiativbewerbung an: 
                    a(href="mailto:bewerbung@bss-hs.de") bewerbung@bss-hs.de
        
</template>

<script>
import Section from "@/components/Section.vue";
import ColumnContainer from "@/components/ColumnContainer.vue";
import { Carousel, Slide } from "vue-carousel";

export default {
    components: { Carousel, Slide, Section, ColumnContainer },
    meta: {
        de: {
            title: "BSS - Karriere",
            description:
                "Die BSS Hochspannungstechnik GmbH ist ein Start-Up im Bereich der Energietechnik, das von Doktoranden des Instituts für Energieübertragung und Hochspannungstechnik (IEH) der Universität Stuttgart im Jahr 2013 gegründet wurde.",
        },
        en: {
            title: "BSS - Career",
            description:
                "BSS Hochspannungstechnik GmbH is a start-up in the field of energy technology, founded in 2013 by doctoral researchers from the Institute of Power Transmission and High Voltage Technology (IEH) at the University of Stuttgart.",
        },
    },
};
</script>

<style lang="sass" scoped>
.padding
    padding: 35px 6.5%

.career-text
    flex: 0 0 60%
    width: 60%

.career-image-column
    flex: 0 0 30%
    width: 30%

.career-carousel
    width: 100%

.career-image
    display: block
    width: 100%
    max-height: 270px
    object-fit: contain

.career-benefits-grid
    display: grid
    grid-template-columns: repeat(6, minmax(0, 1fr))
    gap: 52px 25px
    margin-top: 45px

    > *
        grid-column: span 2

    > :nth-child(4)
        grid-column: 2 / span 2

    > :nth-child(5)
        grid-column: 4 / span 2

.no-bold
    font-weight: normal

@media(max-width: $mobile-breakpoint)
    .career-text, .career-image-column
        flex: 0 0 100%
        width: 100%

    .career-benefits-grid
        display: flex
        flex-direction: column
        align-items: stretch
        gap: 45px

        > *
            width: 100%
.no-margin
    margin-bottom: 0
</style>
